<div class="comments-container">
    <app-comments-layout [componentId]="componentId" [componentName]="componentName" [componentType]="componentType"
        [loggedInUserId]="userId" [layoutMode]="layoutMode" (closePanel)="closeCommentsPanel()"
        (errorEvent)="handleError($event)" [showWhiteHeader]="showWhiteHeader" [isComponentOwner]="isComponentOwner"></app-comments-layout>
</div>